import React, { useState } from "react";
import { useGetOrdersForCompany } from "@/services/Orders";
import { useAuth } from "@/contexts/AuthContext";
import { useTranslation } from "react-i18next";
import DrawerAccordion from "@/components/atoms/accordions/DrawerAccordion";
import { Divider, Grid, Group } from "@mantine/core";
import Text from "@/components/atoms/Text";
import { Controller } from "react-hook-form";
import Checkbox from "@/components/atoms/Checkbox";
import OrderProductDetails from "@/components/molecules/DrawerDetails/OrderProductDetails";
import dayjs from "dayjs";
import OrderDetails from "@/components/molecules/DrawerDetails/OrderDetails";
import OrderStatusEnum from "@/constants/enums/OrderStatusEnum";
import { OrderStatus } from "@/types";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";

const MatchOrderTab = ({ control, setValue: _ }: { control: any; setValue: any }) => {
  const [openAccordion, setOpenAccordion] = useState<string | null>(null);
  const { currentCompany, user } = useAuth();

  const { t } = useTranslation();

  const { data: orders, isLoading: isLoadingOrders } = useGetOrdersForCompany({
    companyId: currentCompany?.companyId as number,
    languageId: user?.language.id,
    includeInactive: true,
    pageNumber: null,
    excludeContractOrders: false,
    limit: 100,
    sortBy: "DATE",
    sortDirection: "DESC",
    statuses: [OrderStatusEnum.AWAITING_FINAL_AMOUNT as OrderStatus],
  });

  return (
    <DrawerAccordion unstyled={true} value={openAccordion} onChange={setOpenAccordion}>
      {orders?.orders.map((order) => {
        const productLabel =
          order.orderProduct ||
          order.companySpecificProductDto?.companySpecificProductName ||
          t("enumerables:plastic." + (order.salesItem?.salesItem ?? ""));
        return (
          <DrawerAccordion.Item key={order.id} value={order.id.toString()}>
            <DrawerAccordion.Control>
              <Group>
                <Controller
                  control={control}
                  name="orderId"
                  render={({ field }) => {
                    const current = field.value as number | null;
                    return (
                      <Checkbox
                        name={field.name}
                        checked={current === order.id}
                        onClick={(e: React.MouseEvent) => e.stopPropagation()}
                        onChange={() => field.onChange(current === order.id ? null : order.id)}
                      />
                    );
                  }}
                />
                <SVGAsset name={order.orderType.type === "SELL" ? "saleIndicator" : "purchaseIndicator"} />
                <Text size="xs" display="technical" tt="uppercase" strong={true}>
                  ID: {order.id} | {productLabel} | {order.amount} {order.unit?.unit} |{" "}
                  {dayjs(order.created).format("DD.MM.YYYY")}
                </Text>
              </Group>
            </DrawerAccordion.Control>
            <DrawerAccordion.Panel>
              <Grid>
                <OrderDetails order={order} isLoading={isLoadingOrders} />
                <Grid.Col span={12}>
                  <Divider />
                </Grid.Col>
                <OrderProductDetails
                  defaultProductName={order.orderProduct || `${order.salesItem.salesItem} - ${order.format?.format}`}
                  product={order.companySpecificProductDto}
                />
              </Grid>
            </DrawerAccordion.Panel>
          </DrawerAccordion.Item>
        );
      })}
    </DrawerAccordion>
  );
};

export default MatchOrderTab;
